import { take, put, cancel, select, takeEvery, call } from 'redux-saga/effects';

import { actions as chatConnectionActions } from '../index';
import {
  loggedUserIdSelector,
  selectSeenSocialChatAlert,
} from '../../context/selectors';
import { actions as targetUserActions } from '../../context';
import { actions as settingsActions } from '../../board/settings';
import { actions as popupActions, socialChatAlertAction } from '../../ui/popup';
import { actions as changeProfileReqActions } from '../../profiles/change-profile-req';

export function* showSocialChatSelectionAlert() {
  const socialChatAlert = yield select(selectSeenSocialChatAlert);

  if (!socialChatAlert) {
    const loggedUserId = yield select(loggedUserIdSelector);
    yield put(socialChatAlertAction());
    yield take(popupActions.hide);
    yield put(
      changeProfileReqActions.send({
        id: loggedUserId,
        seenSocialChatAlert: true,
      }),
    );
  }
}

function* socialChatSelectionWorker({ payload: id }) {
  yield call(showSocialChatSelectionAlert);
  yield put(targetUserActions.clear());
  yield put(settingsActions.removeLastUserId());
  yield put(settingsActions.setLastSocialId({ id }));
  yield put(chatConnectionActions.setActiveChannelId(id));
}

export default function* socialChatSelectionSaga() {
  yield takeEvery(
    [chatConnectionActions.selectSocialChat],
    socialChatSelectionWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/social-chat-selection-saga.js